export default __webpack_public_path__ + "static/media/logout.b221fd66.svg";